import { FlowType } from '@jerry-serverless/types';

import { StepCategory, type AppData } from '../../../types/app_data';
import { growthBookInstance } from '../../../utils/analytics/growthbook';
import type { Step } from '../../types/step';
import { ABTestGarageOnlyInsurance } from '../../../utils/enabled_features/ab_tests';

export const GarageOnlyInsuranceStep: Step = {
  id: 'garageonlyinsurance',
  pathname: '/garageonlyinsurance',
  canShow: (appData: AppData) => {
    return (
      appData.flowType === FlowType.CarValue &&
      growthBookInstance?.getFeatureValue(ABTestGarageOnlyInsurance.storageKey, 0) !== 0
    );
  },
  hasData: () => true,
  hasOwnData: (appData: AppData) => {
    return true;
  },
  category: () => StepCategory.Account,
};
